"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.digitsList = exports.integerInWords = exports.decimalsAreEqual = exports.decimal = exports.roundToNearest = exports.ordinal = exports.hcf = exports.multiple = exports.integerFromList = exports.integerBetween = void 0;
const arrays_1 = require("../arrays");
function integerBetween({ minInt, maxInt }) {
    const range = Math.abs(maxInt - minInt) + 1;
    return Math.min(minInt, maxInt) + Math.floor(Math.random() * range);
}
exports.integerBetween = integerBetween;
function integerFromList({ list }) {
    return (0, arrays_1.oneFromList)({ list });
}
exports.integerFromList = integerFromList;
// Return a multiple of a number, between min and max inclusive.
function multiple({ multipleOf = 0, minInt = 0, maxInt = 0 }) {
    const [actualMin, actualMax] = [minInt, maxInt].sort((a, b) => a - b);
    const minMultiplier = Math.ceil(actualMin / multipleOf);
    const maxMultiplier = Math.floor(actualMax / multipleOf);
    return integerBetween({ minInt: minMultiplier, maxInt: maxMultiplier }) * multipleOf;
}
exports.multiple = multiple;
function hcf({ int1, int2 }) {
    if (!int1 || !int2)
        return 1;
    let [small, big] = [int1, int2].sort((a, b) => a - b);
    return small === big || small === 1 ? small : hcf({ int1: small, int2: big - small });
}
exports.hcf = hcf;
function ordinal({ int }) {
    if (!int)
        return '';
    const j = int % 10;
    const k = int % 100;
    if (j == 1 && k != 11)
        return int + 'st';
    if (j == 2 && k != 12)
        return int + 'nd';
    if (j == 3 && k != 13)
        return int + 'rd';
    return int + 'th';
    ;
}
exports.ordinal = ordinal;
function roundToNearest({ number, toNearest = 1 }) {
    if (number === undefined || toNearest === 0)
        return 0;
    return Math.round(number / toNearest) * toNearest;
}
exports.roundToNearest = roundToNearest;
function decimal({ value, dp }) {
    var _a, _b;
    if (dp === undefined) {
        const long = value.toFixed(12).replace(/[.]?0+$/, '');
        const bits = long.split('.');
        const numDP = (_b = (_a = bits[1]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        return {
            value,
            dp: numDP,
            text: value.toFixed(numDP),
        };
    }
    else {
        return {
            value,
            dp,
            text: value.toFixed(dp),
        };
    }
}
exports.decimal = decimal;
function decimalsAreEqual({ num1, num2, dp = 10 }) {
    const parsed1 = Number(num1);
    const parsed2 = Number(num2);
    return Number.isFinite(parsed1)
        && Number.isFinite(parsed2)
        && parsed1.toFixed(dp) === parsed2.toFixed(dp);
}
exports.decimalsAreEqual = decimalsAreEqual;
const unitsWords = [
    '',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
    'twenty',
];
const tensWords = [
    '',
    'ten',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety',
];
const thousandsWords = [
    '',
    'thousand',
    'million',
    'billion',
];
function tensInWords(tens, units) {
    const value = tens * 10 + units;
    return value > 19
        ? `${tensWords[tens]}${units ? '-' : ''}${unitsWords[units]}`
        : unitsWords[value];
}
function hundredsInWords(int) {
    const [units = 0, tens = 0, hundreds = 0] = String(int).split('').reverse().map((v) => Number(v));
    const hundredsText = hundreds ? `${unitsWords[hundreds]} hundred` : '';
    const tensText = tensInWords(tens, units);
    return hundredsText
        ? `${hundredsText}${tensText ? ` and ${tensText}` : ''}`
        : tensText;
}
function integerInWords({ int }) {
    if (int === 0)
        return 'zero';
    const [rightText, ...rest] = [0, 1, 2, 3]
        .map((i) => Math.floor(int / (10 ** (3 * i))) % 1000)
        .map((group) => hundredsInWords(group))
        .map((groupText, i) => groupText ? `${groupText}${i ? ' ' : ''}${thousandsWords[i]}` : '');
    let leftText = rest.filter((v) => v).reverse().join(', ');
    if (leftText && rightText) {
        leftText += (rightText.indexOf('hundred') > -1 ? ', ' : ' and ');
    }
    return `${leftText}${rightText}`;
}
exports.integerInWords = integerInWords;
function digitsList({ value }) {
    var _a;
    const leftRight = String(value).split('.');
    const digits = leftRight.map((side) => side.split(''));
    const digitValues = [
        ...digits[0].map((digit, i, { length }) => (Number(digit) * 10 ** (length - i - 1)).toFixed(0)),
        ...((_a = digits[1]) !== null && _a !== void 0 ? _a : []).map((digit, i) => (Number(digit) * 10 ** (-i - 1)).toFixed(i + 1)),
    ];
    return {
        value,
        digitValues,
        leftDigits: digits[0],
        rightDigits: digits[1],
        sum: digitValues.join(' + '),
        sumNoSpaces: digitValues.join('+'),
    };
}
exports.digitsList = digitsList;
